<template>
  <div id="hubHeader">
    <b-navbar class="row">
      <b-navbar-brand class="col-2" href="/">
        <div class="">
          <b-img id="headerImage" fluid-grow src="img/TopRibbon4_orange_white.png"></b-img>
        </div>
      </b-navbar-brand>
      <div class='col-5' style="margin-left: 5vw;"></div>
      <!-- <b-navbar-brand class="col-4" style="margin-left: 4.5vw;">
          <b-img height="60" src="img/VSCP.png"></b-img>
      </b-navbar-brand> -->
      <div class="col-3"></div>
      <!-- <div class="col-1" style="margin-left: 3vw;">
        <b-button id="logoutButton" variant="outline-dark" @click="logout">
          <b-img id="headerImage" fluid-grow src="img/power_white.svg"></b-img>
        </b-button>
      </div> -->
    </b-navbar>
  </div>
</template>
<script>
/*eslint-disable*/
  export default {
    name: 'HubHeader',
    methods: {
      logout() {
        console.log("logout clicked");
        const current = this
        current.$store.commit("mainStore/storeAccessToken", "")
        sessionStorage.removeItem("accessToken")
        current.$router.push("/")
        current.$notify({
          group: 'notification_01',
          title: 'Logout Successful',
          text: '',
          type: "success",
          duration: 1500
        });
      }
    }
  }
</script>
<style>
  #hubHeader {
    width: 100vw!important;
    height: 7vh!important;
    background: rgba(128, 128, 128, 0.4)!important;
    /* opacity: 0.5; */
  }
  .navbar {
    padding-top: 0;
    padding-bottom: 0;
  }
  .pull-right {
    float: right !important;
  }
  #logoutButton {
    width: 4vw!important;
    height: 7vh!important;
    border: none;
    padding-top: 2px;
    padding-bottom: 2px;
  }
  #headerImage {
    padding-top: 2px;
    padding-bottom: 2px;
  }
  /* #test {
    width: 100vw!important;
    height: 8vh!important;
    background-color: green;
  } */
</style>
